import { gql, useQuery } from '@apollo/client'

const GET_LENDERS_FOR_VERTICAL = gql`
  query GET_LENDERS_FOR_VERTICAL(
    $vertical: String!
    $loanPurpose: String
    $withMetadata: Boolean = false
  ) {
    getLendersForVertical(vertical: $vertical, loanPurpose: $loanPurpose) {
      slug
      name
      metadata @include(if: $withMetadata)
    }
  }
`

const useActiveLenders = (
  vertical,
  loanPurpose,
  provideFullResults = false,
  withMetadata = false,
) => {
  const { error, loading, data } = useQuery(GET_LENDERS_FOR_VERTICAL, {
    variables: { vertical, loanPurpose, withMetadata },
  })

  if (provideFullResults) {
    return { error, loading, data }
  }

  return data ? data.getLendersForVertical : []
}

export default useActiveLenders
